import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-five-steps-team',
  templateUrl: './five-steps-team.component.html',
  styleUrls: ['../../participants-resources/participants-resources.scss']
})
export class FiveStepsTeamComponent implements OnInit {
  public isStep1Collapsed = false;
  public isStep2Collapsed = false;
  public isStep3Collapsed = false;
  public isStep4Collapsed = false;

  constructor() { }

  ngOnInit() {
  }

}
